import React, { useState, useCallback, useEffect } from 'react';
import HeroCarousel from '@/components/ui/HeroCarousel';
import MovieCarousel from '@/components/ui/MovieCarousel';
import MovieModal from '@/components/ui/MovieModal';
import { PageSkeleton } from '@/components/ui/LoadingSkeleton';
import { fetchTrending, fetchTopRated, fetchByGenre, GENRES } from '@/services/tmdb';

const HomePage = () => {
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // State for data
  const [heroMovies, setHeroMovies] = useState([]);
  const [trendingMovies, setTrendingMovies] = useState([]);
  const [topRatedMovies, setTopRatedMovies] = useState([]);
  const [actionMovies, setActionMovies] = useState([]);
  const [comedyMovies, setComedyMovies] = useState([]);
  const [scifiMovies, setScifiMovies] = useState([]);
  const [horrorMovies, setHorrorMovies] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [
          trending,
          topRated,
          action,
          comedy,
          scifi,
          horror
        ] = await Promise.all([
          fetchTrending(),
          fetchTopRated(),
          fetchByGenre(GENRES.ACTION),
          fetchByGenre(GENRES.COMEDY),
          fetchByGenre(GENRES.SCIFI),
          fetchByGenre(GENRES.HORROR),
        ]);

        setHeroMovies(trending.results.slice(0, 5)); // Top 5 for hero
        setTrendingMovies(trending.results);
        setTopRatedMovies(topRated.results);
        setActionMovies(action.results);
        setComedyMovies(comedy.results);
        setScifiMovies(scifi.results);
        setHorrorMovies(horror.results);
      } catch (error) {
        console.error("Failed to load TMDb data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  // Handle showing movie details
  const handleShowDetails = useCallback((movie) => {
    setSelectedMovie(movie);
    setIsModalOpen(true);
  }, []);

  // Handle closing modal
  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedMovie(null), 300);
  }, []);

  if (isLoading) {
    return <PageSkeleton />;
  }

  return (
    <main className="min-h-screen bg-background">
      {/* Hero Section */}
      <HeroCarousel
        movies={heroMovies}
        onShowDetails={handleShowDetails}
      />

      {/* Movie Categories */}
      <section className="relative z-30 mt-4 md:-mt-24 pb-12 md:pb-16 px-4 md:px-12 space-y-8">
        <MovieCarousel title="Tendencias" movies={trendingMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Mejor Valoradas" movies={topRatedMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Acción" movies={actionMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Comedia" movies={comedyMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Ciencia Ficción" movies={scifiMovies} onShowDetails={handleShowDetails} />
        <MovieCarousel title="Terror" movies={horrorMovies} onShowDetails={handleShowDetails} />
      </section>

      {/* Movie Detail Modal */}
      <MovieModal
        movie={selectedMovie}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </main>
  );
};

export default HomePage;
